class ShoedealInfoHotspots extends HTMLElement {
  connectedCallback() {
    if (this.dataset.sdInitialized === 'true') return;

    this.dataset.sdInitialized = 'true';
    this.mobileQuery = window.matchMedia('(max-width: 749px)');

    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
    document.addEventListener('click', this.handleDocumentClick);

    this.buildMobileList();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener(
      'click',
      this.handleDocumentClick
    );

    delete this.dataset.sdInitialized;
  }

  get hotspots() {
    return Array.from(
      this.querySelectorAll('[data-sd-hotspot]')
    );
  }

  buildMobileList() {
    const list = this.querySelector(
      '[data-sd-hotspot-mobile-list]'
    );

    if (!list) return;

    list.replaceChildren();

    this.hotspots.forEach((hotspot, index) => {
      const trigger = hotspot.querySelector(
        '[data-sd-hotspot-trigger]'
      );

      const title = hotspot.querySelector(
        '.sd-info-hotspot__title'
      );

      const hotspotText = hotspot.querySelector(
        '.sd-info-hotspot__text'
      );

      const markerText =
        trigger?.textContent?.trim() ||
        String(index + 1);

      const item = document.createElement('article');
      item.className = 'sd-info-hotspots__mobile-item';

      const marker = document.createElement('span');
      marker.className =
        'sd-info-hotspots__mobile-marker';

      marker.setAttribute('aria-hidden', 'true');
      marker.textContent = markerText;

      const content = document.createElement('div');
      content.className =
        'sd-info-hotspots__mobile-content';

      if (title) {
        const mobileTitle =
          document.createElement('h3');

        mobileTitle.className =
          'sd-info-hotspots__mobile-title';

        mobileTitle.textContent =
          title.textContent.trim();

        content.appendChild(mobileTitle);
      }

      if (hotspotText) {
        const mobileText =
          hotspotText.cloneNode(true);

        mobileText.classList.remove(
          'sd-info-hotspot__text'
        );

        mobileText.classList.add(
          'sd-info-hotspots__mobile-text'
        );

        content.appendChild(mobileText);
      }

      item.append(marker, content);
      list.appendChild(item);
    });
  }

  openHotspot(hotspot) {
    if (!hotspot || this.mobileQuery.matches) return;

    const trigger = hotspot.querySelector(
      '[data-sd-hotspot-trigger]'
    );

    const dialog = hotspot.querySelector(
      '[data-sd-hotspot-dialog]'
    );

    if (!trigger || !dialog) return;

    this.closeAll(hotspot);

    dialog.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');

    hotspot.classList.add('is-open');
    this.classList.add('has-open-hotspot');
  }

  closeHotspot(hotspot, returnFocus = false) {
    if (!hotspot) return;

    const trigger = hotspot.querySelector(
      '[data-sd-hotspot-trigger]'
    );

    const dialog = hotspot.querySelector(
      '[data-sd-hotspot-dialog]'
    );

    if (!trigger || !dialog) return;

    dialog.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');

    hotspot.classList.remove('is-open');

    if (
      !this.querySelector(
        '[data-sd-hotspot].is-open'
      )
    ) {
      this.classList.remove('has-open-hotspot');
    }

    if (returnFocus && !this.mobileQuery.matches) {
      trigger.focus();
    }
  }

  closeAll(except = null) {
    this.hotspots.forEach((hotspot) => {
      if (hotspot !== except) {
        this.closeHotspot(hotspot);
      }
    });
  }

  handleClick(event) {
    const trigger = event.target.closest(
      '[data-sd-hotspot-trigger]'
    );

    const closeButton = event.target.closest(
      '[data-sd-hotspot-close]'
    );

    const backdrop = event.target.closest(
      '[data-sd-hotspot-backdrop]'
    );

    if (trigger && this.contains(trigger)) {
      event.preventDefault();
      event.stopPropagation();

      if (this.mobileQuery.matches) return;

      const hotspot = trigger.closest(
        '[data-sd-hotspot]'
      );

      const isOpen =
        hotspot.classList.contains('is-open');

      if (isOpen) {
        this.closeHotspot(hotspot);
      } else {
        this.openHotspot(hotspot);
      }

      return;
    }

    if (
      closeButton &&
      this.contains(closeButton)
    ) {
      event.preventDefault();
      event.stopPropagation();

      const hotspot = closeButton.closest(
        '[data-sd-hotspot]'
      );

      this.closeHotspot(hotspot, true);
      return;
    }

    if (backdrop && this.contains(backdrop)) {
      event.preventDefault();
      this.closeAll();
    }
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.closeAll();
    }
  }

  handleKeydown(event) {
    if (event.key !== 'Escape') return;
    if (this.mobileQuery.matches) return;

    const openHotspot = this.querySelector(
      '[data-sd-hotspot].is-open'
    );

    if (openHotspot) {
      this.closeHotspot(openHotspot, true);
    }
  }
}

if (!customElements.get('shoedeal-info-hotspots')) {
  customElements.define(
    'shoedeal-info-hotspots',
    ShoedealInfoHotspots
  );
}